<template>
  <div class="content-page">
    <navigator :items="items"></navigator>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12">
                  <div class="title-section">Conteúdo</div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label for>Título</label>
                    <input type="text" v-model="content_page.title" class="form-control" disabled />
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label for>
                      Texto
                      <span class="required-field">*</span>
                    </label>
                    <text-editor-component
                      :textContent="content_page.content"
                      @updateContentComponent="updateContent"
                    ></text-editor-component>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <button class="btn btn-primary float-right" v-on:click="save()">Salvar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import TextEditorComponent from "@/components/inputs/TextEditorComponent";
import Swal from "sweetalert2";
import { bus } from "@/main";

export default {
  name: "content-page",
  props: {
    id: Number
  },
  components: {
    TextEditorComponent
  },
  data() {
    return {
      content_page: {},
      formType: "create",
      text: {},
      items: [
        {
          text: "Conteúdo das páginas",
          route: "admin.pages"
        },
        {
          text: "Conteúdo",
          active: true
        }
      ]
    };
  },
  mounted() {
    bus.$emit("changeLoading", true);
    this.getDataObject(this.id);
  },
  methods: {
    getDataObject: function(id) {
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/content_pages/${id}`)
        .then(response => {
          this.content_page = response.data;
          bus.$emit("changeLoading", false);
        });
    },
    updateContent: function(val) {
      this.content_page.content = val;
    },
    save: function() {
       bus.$emit("changeLoading", true);
      if (this.content_page.content != "") {
        let promise = axios.put(
          `${process.env.VUE_APP_API_HOST}/api/content_pages/${this.content_page.id}`,
          this.content_page
        );

        promise
          .then(response => {
             bus.$emit("changeLoading", false);
            Swal.fire({
              title: "Item alterado com sucesso",
              icon: "success",
              onClose: () => {
                this.$router.push({ name: "admin.pages" });
              }
            });
          })
          .catch(error => {
            bus.$emit("changeLoading", false);
            Swal.fire({
              title: "Ocorreu um erro.",
              icon: "error"
            });
          });
      } else {
        Swal.fire({
          title: "Atenção",
          text: "O campo Texto é necessário",
          icon: "warning"
        });
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";
</style>